import { FunctionComponent } from 'react'
import DashboardLayout from '../../components/layout/layout'
import { Box, Button, Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import StorageService from '../../services/storageService'
import { useGetChannelPartnerOEntryHeaderCartCancel } from '../../hooks/api/oms'

const OnlineOrderEntryOrderCancel: FunctionComponent = () => {
  const navigate = useNavigate();
  const { mutateAsync: cancelCart } = useGetChannelPartnerOEntryHeaderCartCancel();

  const handleConfirm = async () => {
    StorageService.clearCart();
    await cancelCart();
    navigate('/order-management-system/online-order-entry/order/cancel-confirm');
  };

  return (
    <DashboardLayout title={"Orders Management"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={"Online Order Entry"} breadcrumbs={'Cancel Order'} activeMenu={'oms'}>
      <Grid container sx={{ padding: '0px 20px 20px 0px' }}>
        <Grid size={8}>
          <Typography variant="h6">
            Are you sure you want to cancel this order?
          </Typography>
          <Box sx={{ mt: 3, display: "flex", alignItems: "center", gap: 3 }}>
            <Button variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '100px' }} onClick={handleConfirm}>
              YES
            </Button>
            <Button variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '100px' }} onClick={() => navigate(-1)}>
              NO
            </Button>
          </Box>
        </Grid>
        <Grid size={4}>
          <Box
            sx={{
              width: 0,
              height: 0,
              borderLeft: '60px solid transparent',
              borderRight: '60px solid transparent',
              borderBottom: '94.6px solid #dc0f4b',
            }}
          />
        </Grid>
      </Grid>
    </DashboardLayout>
  )
}

export default OnlineOrderEntryOrderCancel